const getters = {
  device: state => state.app.device,
  theme: state => state.app.theme,
  color: state => state.app.color,
  token: state => state.user.token,
  userId: state => state.user.userId,
  avatar: state => state.user.avatar,
  nickname: state => state.user.name,
  crossBorder: state => state.user.crossBorder,
  welcome: state => state.user.welcome,
  roles: state => state.user.roles,
  menus: state => state.user.menus,
  userInfo: state => state.user.info,
  addRouters: state => state.permission.addRouters,
  routers: state => state.permission.routers,
  multiTab: state => state.app.multiTab,
  lang: state => state.i18n.lang
}

export default getters
